<template>
    <div class="lg:flex">
        <div class="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
             style="background-image: url('/img/contact2.jpeg')"
             title="E. Budding Vloerverwarmingen">
        </div>
        <div class="border-r border-b border-l border-grey-light lg:border-l-0 lg:border-t lg:border-grey-light bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
            <div class="mb-8">
                <div class="text-black font-bold text-xl mb-2">E. Budding Vloerverwarmingen</div>
                <p class="text-grey-darker text-base">
                    {{contents.pages.contact.content.block1.street}}<br>
                    {{contents.pages.contact.content.block1.postal_code}}<br>
                    {{contents.pages.contact.content.block1.tel}}<br>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ContactInformation",
        props: ['contents']
    }
</script>

<style scoped>

</style>
